import PersonIcon from '@mui/icons-material/Person'
import { useMediaQuery } from '@mui/material'
import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'
import Grid from '@mui/material/Grid2'
import MenuList from '@mui/material/MenuList'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { map } from 'lodash'
import moment from 'moment'
import { useEffect } from 'react'
import { useAssistantAdministrationStore } from '../../../../store/storeAssistantAdministration'
import { ReplyActor } from '../../../../swagger/dto'
import { theme } from '../../../../theme'

export const Stenograhy = ({ recordId }) => {
    const isMobile = useMediaQuery(theme.breakpoints.down('md'))
    const {
        isLoadingFetchStenographyList,
        isLoadingFetchStenographyDetail,
        fetchStenographyList,
        stenographyList,
        errorFetchStenographyList,
        fetchStenographyDetail,
        stenographyDetail,
        errorFetchStenographyDetail,
    } = useAssistantAdministrationStore((state) => state)

    useEffect(() => {
        fetchStenographyList({
            record_id: recordId,
        })
    }, [])

    useEffect(() => {
        if (stenographyList && stenographyList.length > 0) {
            fetchStenographyDetail({ recordStenographyId: stenographyList[0].id })
        }
    }, [stenographyList])

    return (
        <div>
            {stenographyDetail && stenographyDetail?.chunks?.length > 0 && (
                <MenuList
                    sx={{
                        p: 0,
                        height: `calc(100dvh - ${264}px)`,
                        overflowY: 'auto',
                    }}>
                    {map(stenographyDetail.chunks, (item, index) => {
                        const { text, id, actor, created_at, start_second, speaker_name } = item
                        return (
                            <>
                                <Grid
                                    spacing={0}
                                    key={id}
                                    container
                                    sx={{
                                        position: 'relative',
                                        padding: isMobile ? 1 : 2,
                                        '&:hover button ': {
                                            visibility: 'visible',
                                        },
                                    }}>
                                    <Grid
                                        alignItems="bottom"
                                        alignContent="flex-start"
                                        spacing={0}
                                        sx={{ width: '100%', m: 0 }}>
                                        <Stack direction="row" spacing={1} sx={{ width: '100%' }}>
                                            {!isMobile && (
                                                <Box
                                                    sx={{
                                                        textAlign: 'center',
                                                        marginTop: 1,
                                                    }}>
                                                    <Box
                                                        sx={{
                                                            background:
                                                                actor === ReplyActor.USER
                                                                    ? '#FFD702'
                                                                    : '#006CFD',
                                                            width: '36px',
                                                            height: '36px',
                                                            borderRadius: '50%',
                                                        }}>
                                                        <PersonIcon
                                                            sx={{
                                                                color: '#fff',
                                                                paddingTop: '4px',
                                                                fontSize: '27px',
                                                            }}
                                                        />
                                                    </Box>
                                                </Box>
                                            )}

                                            <Box sx={{ width: '100%' }}>
                                                <Typography
                                                    variant="caption2"
                                                    sx={{
                                                        color: isMobile ? '#004B9F' : '#9195A1',
                                                    }}>
                                                    {speaker_name ?? 'Неизвестный спикер' }
                                                </Typography>
                                                <Typography
                                                    variant="caption2"
                                                    sx={{
                                                        color: '#9195A1',
                                                        marginLeft: 1,
                                                    }}>
                                                    {moment
                                                        .utc(start_second * 1000)
                                                        .format('HH:mm:ss')}
                                                </Typography>

                                                <Box sx={{ width: '100%', mе: 2 }}>{text}</Box>
                                            </Box>
                                        </Stack>
                                    </Grid>
                                </Grid>
                            </>
                        )
                    })}
                </MenuList>
            )}
            {stenographyDetail?.chunks?.length === 0 ||
            stenographyList?.length === 0 ||
            errorFetchStenographyDetail ||
            errorFetchStenographyList ? (
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                    <Typography color="error"> Стенография не найдена </Typography>
                </Box>
            ) : (
                ''
            )}

            {(isLoadingFetchStenographyList || isLoadingFetchStenographyDetail) && (
                <CircularProgress sx={{ textAlign: 'center' }} />
            )}
        </div>
    )
}
